import { Gateways } from '@/typescript/types/global/Gateways'

class PaymentMethodTransformHelper {
  static transformToPaymentMethod(gateways: Gateways) {
    return Object.keys(gateways).map((key, index) => ({
      id: index,
      name: 'payment',
      value: 'card',
      checked: true,
      label: gateways[key].name,
    }))
  }

  static transformToTitleValue(gateways: Gateways) {
    return Object.keys(gateways).map(key => ({
      title: gateways[key].name,
      value: key,
    }))
  }
}

export default PaymentMethodTransformHelper
